module.exports = "<footer class=\"main-footer\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-sm-12\">\n        <p>\n          ©\n          <a href=\"#\">\n            UST Inc.\n          </a>\n          All Rights are Reserved\n        </p>\n      </div>\n      <div class=\"col-sm-6 text-right\">\n        <p></p>\n      </div>\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cqm-ns/cqm-ns-footer/cqm-ns-footer.component.html
// module id = ./src/app/modules/cqm-ns/cqm-ns-footer/cqm-ns-footer.component.html
// module chunks = main